import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Add20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.75 9.25V1H9.25V9.25H1V10.75H9.25V19H10.75V10.75H19V9.25H10.75Z'
      fill='currentColor'
    />
  </Svg>
);

Add20.displayName = 'Add20';
export default Add20;
